import { ROUTER_PATHS } from "@/shared/constants"
import { Navigate, useSearchParams } from "react-router-dom"
import { useUserStore } from "@/entities"
import {
  completeExtensionAuth,
  isTrustedExtensionContinuation,
} from "@/shared/utils/complete-extension-auth"
import { useEffect, useRef } from "react"
import { ConfirmEmailWidget } from "@/widgets"

export const AuthRoute = ({ children }: { children: React.ReactNode }) => {
  const { access_token, isEmailConfirmed, isGuest } = useUserStore()
  const [searchParams] = useSearchParams()
  const extensionAuthorize = searchParams.get("extension_authorize")
  const completing = useRef(false)

  useEffect(() => {
    if (
      !access_token ||
      !extensionAuthorize ||
      (!isGuest && !isEmailConfirmed) ||
      completing.current
    ) return
    completing.current = true
    void completeExtensionAuth(extensionAuthorize).catch(() => {
      // Older backends can still complete the flow using the browser cookie.
      if (isTrustedExtensionContinuation(extensionAuthorize)) {
        window.location.replace(extensionAuthorize)
      } else {
        window.location.replace(ROUTER_PATHS.APP)
      }
    })
  }, [access_token, extensionAuthorize, isEmailConfirmed, isGuest])

  if (access_token) {
    if (extensionAuthorize) {
      if (!isGuest && !isEmailConfirmed) {
        return <ConfirmEmailWidget />
      }
      return null
    }
    return <Navigate to={ROUTER_PATHS.APP} replace />
  }

  return <>{children}</>
}
